import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, Camera, BookOpen, Sprout, FlaskConical } from "lucide-react";

export default function BottomNav() {
  const { t } = useTranslation();
  const items = [
    { to: "/dashboard", icon: Home, label: t("nav.home"), testid: "nav-home" },
    { to: "/diagnosi", icon: Camera, label: t("nav.diagnose"), testid: "nav-diagnose" },
    { to: "/concimi", icon: Sprout, label: t("nav.fertilizer"), testid: "nav-fertilizer" },
    { to: "/quaderno", icon: BookOpen, label: t("nav.journal"), testid: "nav-journal" },
    { to: "/catalogo", icon: FlaskConical, label: t("nav.catalog"), testid: "nav-catalogo" },
  ];
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 vs-bottom-nav"
      style={{
        background: "var(--surface)",
        borderTop: "2px solid var(--border)",
        zIndex: 40,
      }}
      data-testid="bottom-nav"
    >
      <div className="max-w-2xl mx-auto grid grid-cols-5">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-3 transition-colors ${
                  isActive ? "" : ""
                }`
              }
              style={({ isActive }) => ({
                color: isActive ? "var(--primary)" : "var(--text-muted)",
                fontWeight: isActive ? 700 : 500,
                borderTop: isActive ? "3px solid var(--primary)" : "3px solid transparent",
                marginTop: "-2px",
              })}
            >
              <Icon size={22} strokeWidth={2.2} />
              <span className="text-xs">{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
